<template>
    <div class="layer dialogLayer mask50" v-show="visible">

        <div class="dialog white_bg" :class="{roundBorder8 : roundBorder}">

            <header class="dialogHeader generalPagePaddingH alignCenter relative" style="height: 40px; line-height: 40px;
                border-bottom: solid 1px #B3B3B3;">
                <div class="inner">
                    <strong class="bold orange">{{dataItem ? dataItem.title : ''}}</strong>
                    <span class="closeButton fr font24r absolutePosition" style="right: 10px; top: 0;"
                          @click="close()">&times;</span>
                </div>
            </header>

            <div class="dialogBody font14r paddingH16">
                <p class="giftNotice">{{dataItem ? dataItem.introduce : ''}}</p>
                <div class=" giftItem" style="color: #101010;" v-for="(giftItem, giftIndex) in (dataItem ? dataItem.reList : [])"
                     :key="giftIndex" :data-content="dataItem ? dataItem.content : ''">
                    <label class="block" style="padding-right: 15px;">
                        {{giftItem.title}}
                        <input type="checkbox" class="checkbox orangeCircleTickCheckbox" :value="giftItem.bindBizInfo.id"
                           v-model="selectedIds"
                           :disabled="selectedIds.length >= dataItem.receiveLimit && !isSelectedGiftId(giftItem.bindBizInfo.id)"
                           @change="onChangeGift" @click="onClickGift"/>
                    </label>

                </div>
            </div>

            <footer class="dialogFooter alignC paddingB12">
                <button class="receiveButton" @click="receive()">立即领取</button>
            </footer>

        </div>
    </div>

</template>

<script>
import dialogPart from './part/dialogPart';

// data and api
import welfareApi from "@api/welfare";

// util
import arrayHelper    from "@/util/arrayHelper";
import appHelper    from "@/util/appHelper";

const config = {
    apiConfig : {
        get : {
            url : 'portal/welfare',
            params : {
                typeEnum : 'NEW_USER'
            }
        }
    }
};
export default {
    name: "newPeopleGiftDialog",
    extends : dialogPart,
    props : {
        width: {
            type : Number,
            default : 280
        }
    },
    data() {
        return {
            title : '新人福利领取',
            apiConfig : config.apiConfig,

            enableDataItem : true,
            autoLoadDataItem : true,

            giftList : [{
                id : '1',
                title : '福利一：新手班主任必看三节课免费学！',
                checked : false,
            },{
                id : '2',
                title : '福利二：简单易学奥尔夫新优势免费学！',
                checked : false,
            },{
                id : '3',
                title : '福利三：幼师体验资料包免费下载学习！',
                checked : false,
            }],

            selectedIds : []
        }
    },
    methods : {
        onLoadDataItem() {
            // this.dataItem properties: canReceive, hasReceive, id, interactionList, introduce, reList
            // receiveLimit, received, title, type
            // this.dataItem 为空则代表超出领取期限
            // this.dataItem.hasReceive 为 false 才能领取
            if (this.dataItem && !this.dataItem.hasReceive)
            {
                this.show();
            }
        },
        onChangeGift(event) {

            if (this.dataItem.receiveLimit && this.selectedIds.length > this.dataItem.receiveLimit)
            {
                appHelper.showHint('最多选择' + this.dataItem.receiveLimit + '个');
            }
        },
        onClickGift(event) {

            let target = event.currentTarget;

            if (target.disabled && this.dataItem.receiveLimit && this.selectedIds.length >= this.dataItem.receiveLimit)
            {
                appHelper.showHint('最多选择' + this.dataItem.receiveLimit + '个');
            }
        },

        isSelectedGiftId(id) {
            return arrayHelper.existElement(id, this.selectedIds);
        },
        receive() {
            if (this.dataItem.receiveLimit && this.selectedIds.length > this.dataItem.receiveLimit)
            {
                appHelper.showHint('最多选择' + this.dataItem.receiveLimit + '个');
                return;
            }

            welfareApi.receive({
                id : this.dataItem.id,
                bizId : JSON.stringify(this.selectedIds)
            }, (result) => {
                appHelper.showHint('领取成功');
                appHelper.goToPage('newPeopleGiftReceiveSuccess', {
                    id : this.dataItem.id
                });
            });

        }
    }
}
</script>
<style lang="scss" scoped>
.dialogLayer {
    display: grid;
    align-content: center;
    justify-content: center;
}
.dialog {
    min-height: 120px;
    width: 280px;
}
@media screen and (min-width: 375px) {
    .dialog {
        width: 320px;
    }
}
.orange {
    color: #F4950E;
}
/* 接收按钮 */
.receiveButton {
    width: 238px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    //background: #ffa01a;
    background: #F4950E;
    color: white;
    border: none;
}
/* 福利的说明文字 */
.giftNotice {
    color: red;
}
/* 福利的内容行 */
.giftItem {
    position: relative;
    margin-bottom: 8px;

    // 复选框
    .checkbox {
        float: right;
        position: absolute;
        top: 0;
        right: 0;
    }
}
</style>
